import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { configs } from "../config";

export const eFileApis = createApi({
  reducerPath: "eFileApis",
  baseQuery: fetchBaseQuery({
    baseUrl: configs.courtConnectBaseUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("Access-Control-Allow-Methods", "GET,PUT,POST,DELETE,PATCH,OPTIONS");
      return headers;
    }
  }),
  endpoints: (builder) => ({
    getEFileOptions: builder.query({
      query: (params) => ({
        method: "POST",
        url: "EFileOptions",
        body: params
      })
    }),
    getEFileQuestions: builder.mutation({
      query: (eFileOptionId) => ({
        method: "POST",
        url: "EFileQuestions",
        body: eFileOptionId
      })
    }),
    submitEFile: builder.mutation({
      query: (eFile) => ({
        method: "POST",
        url: "InsertEFileRequest",
        body: eFile
      })
    }),
    getCivilCaseTypes: builder.query({
      query: (params) => ({
        method: "POST",
        url: "GetCivilCaseTypes",
        body: params
      })
    }),
    submitCivilEFile: builder.mutation({
      query: (eFile) => ({
        method: "POST",
        url: "SubmitCivilEFile",
        body: eFile
      })
    }),
  })
});

export const { useGetEFileQuestionsMutation, useGetEFileOptionsQuery, useSubmitEFileMutation, useGetCivilCaseTypesQuery, useSubmitCivilEFileMutation } = eFileApis;
